export const css = {
    loading: '_239func6',
    ' _key': 'quiz-widgets/loading'
};
export default css;
